<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title mb-4">
          {{ $t("Distributor Share Summary Week Wise Report") }}
        </div>
        <div class="mt-3 border-bottom">
          <div class="row">
            <div class="col-lg-6 col-xl-3 mb-4">
              <div class="input-material">
                <div class="add-datepicker">
                  <Datepicker
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                    :monday-first="true"
                    typeable
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">Show From Date</label>
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 mb-4">
              <div class="input-material">
                <div class="add-datepicker">
                  <Datepicker
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                    :monday-first="true"
                    typeable
                  ></Datepicker>
                  <!-- disabled -->
                  <label :class="toDate ? 'active' : ''">Show To Date</label>
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 mb-4">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="selectedCinema ? 'shift-up' : ''">
                    {{ "Select Cinema" }}
                  </label>
  
                  <multiselect
                    id="cine_id"
                    v-model="selectedCinema"
                    :multiple="false"
                    :options="Cinemas"
                    deselect-label="Remove"
                    label="cine_name"
                    name="cine_id"
                    placeholder=""
                    select-label="Select"
                    track-by="cine_id"
                    @remove="onRemoveHandler($event, 'cinema')"
                    @select="onSelectHandler($event, 'cinema')"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 mb-4">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="selectedDistributor && selectedDistributor.hasOwnProperty('d_id') ? 'shift-up' : ''"
                  >
                    {{ "Distributor" }}
                  </label>
  
                  <multiselect
                    id="d_id"
                    v-model="selectedDistributor"
                    :options="getDistributorReportDropdownList"
                    deselect-label="Remove"
                    label="d_company_name"
                    name="d_id"
                    placeholder=""
                    select-label="Select"
                    track-by="d_id"
                    @input="onSelectHandler($event, 'distributor')"
                    @remove="onRemoveHandler($event, 'distributor')"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 mb-4">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label :class="selectedMovie.length > 0 ? 'shift-up' : ''">
                    {{ "Movie" }}
                  </label>
  
                  <multiselect
                    id="movie_id"
                    v-model="selectedMovie"
                    :multiple="true"
                    :options="MovieList"
                    deselect-label="Remove"
                    label="movie_title"
                    name="movie_id"
                    placeholder=""
                    select-label="Select"
                    track-by="movie_id"
                    @remove="onRemoveHandler($event, 'movie')"
                    @select="onSelectHandler($event, 'movie')"
                  >
                  </multiselect>
                </div>
              </div>
            </div>
  
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent.stop="getDistributorShareData('N','N')"
              >
                {{ $tc("Fetch Report") }}
              </button>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
         
        </div>
        <div  v-if="distributorShareSummaryData.length" class="col-lg-6 col-xl-3 d-flex justify-content-end align-self-center mb-3">
          <img
          @click="getDistributorShareData('Y','N')"
              class="cursor-pointer"
              height="25"
              src="@/assets/img/icons/pdf-icon.svg"
              width="25"
            />

            <img  @click="getDistributorShareData('N','Y')" class="cursor-pointer ml-1"
            height="25" src="@/assets/img/icons/excel.svg" width="25" />
      </div>
          </div>
          <div class="swc-report">
            <table border="1" class="swc-report-table">
              <thead class="color-blue text-bold">
                <tr>
                  <th>Distributor Name</th>
                  <th>Movie Name</th>
                  <th>Release Date</th>
                  <th>Average Tkt Price</th>
                  <th>Admits</th>
                  <th>Comps</th>
                  <th class="_net2">GRS Amount</th>
                  <th class="_net2no3d">VAT Amount</th>
                  <th>M-Tax Amount</th>
                  <th>Net Amount</th>
                  <th>Share Value</th>
                </tr>
              </thead>
              <tbody v-if="distributorShareSummaryData.length">
                <template
                  v-for="(week, weekindex) in distributorShareSummaryData"
                >
                <tr class="color-blue text-bold text-left">
                    <td colspan="11">{{week.name}}</td>
                </tr>
                <tr v-if="week.weekData && week.weekData.length"  v-for="(movie, movieIndex) in week.weekData"
                :key="movieIndex">
                  <td class="text-left">
                    {{ movie.dist_company_name || "-" }}
                  </td>
                  <td class="text-left">
                    {{ movie.movie_name || "-" }}
                  </td>
                  <td class="text-left">
                    {{
                      movie.mrrdr_release_date
                        ? moment(movie.mrrdr_release_date).format("YYYY-MM-DD")
                        : moment(movie.original_release_date).format(
                            "YYYY-MM-DD"
                          ) || "-"
                    }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(movie.total_average_ticket_price || 0) || "-" }}
                  </td>
                  <td class="text-right">
                    {{ movie.total_admits || "-" }}
                  </td>
                  <td class="text-right">
                    {{ movie.total_compplementory_ticket || "-" }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(movie.total_gross_amount || 0) || "-" }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(movie.total_vat || 0) || "-" }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(movie.total_mtax || 0) || "-" }}
                  </td>
  
                  <td class="text-right">
                    {{ currFormat(movie.total_net_amount || 0) || "-" }}
                  </td>
                  <td class="text-right">
                    {{ currFormat(movie.total_share_value || 0) || "-" }}
                  </td>
                </tr>
                <tr v-if="!week.weekData || !week.weekData.length" ><td colspan="8" class="text-center">No Records</td></tr>
                <tr class="color-blue text-bold text-left">
                    <td >{{week.name}} Total</td>
                    <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">{{ week.weekTotal.admits || 0 }}</td>
                  <td class="text-right">{{ week.weekTotal.complementary_tickets || 0 }}</td>
                  <td class="text-right">{{ currFormat(week.weekTotal.total_gross ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(week.weekTotal.total_vat ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(week.weekTotal.total_mtax ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(week.weekTotal.total_net ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(week.weekTotal.total_share_value ||0) || "-" }}</td>
                </tr>
                <tr> <td colspan="11"></td>
                </tr>
                </template>
                <tr class="color-blue text-bold">
                  <td>Grand Total</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text-right">{{ grandTotal.admits }}</td>
                  <td class="text-right">{{ grandTotal.complementary_tickets }}</td>
                  <td class="text-right">{{ currFormat(grandTotal.total_gross ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(grandTotal.total_vat ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(grandTotal.total_mtax ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(grandTotal.total_net ||0) || "-" }}</td>
                  <td class="text-right">{{ currFormat(grandTotal.total_share_value ||0) || "-" }}</td>
                </tr>
              </tbody>
              <tbody v-else class="" >
                  <td colspan="11" class="text-center">No Records</td>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { CLIENT_NAME } from "@/helper/Role";
  import { mapActions, mapGetters } from "vuex";
  import moment from "moment";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService";
  import ReportsServiceV2 from "@/services/ReportsService-v2";
  
  import { authenticationService } from "@/services/AuthenticationService";
  
  export default {
    name: "distributorShareSummaryReport",
    data() {
      return {
        Cinemas: [],
        MovieList: [],
        selectedMovie: [],
        selectedCinema: "",
        selectedDistributor: [],
        movie_id: null,
        d_id: null,
        cinema_id: null,
        fromDate: new Date(),
        toDate: new Date(),
        distributorShareSummaryData: [],
        grandTotal: {}
      };
    },
    beforeMount() {
      this.getCinemaList();
      this.fetchReportDistributorsList();
    },
    computed: {
      ...mapGetters([
        "getDistributorReportDropdownList"
        //   "getDistributorReportMoviesList",
      ]),
      distributorIds() {
        let text = ``;
        if (this.selectedDistributor.length > 0) {
          text = this.selectedDistributor.map(x => x.d_id).join(",");
        }
  
        return text;
      },
      movieIds() {
        let text = ``;
        if (this.selectedMovie.length > 0) {
          text = this.selectedMovie.map(x => x.md_id).join(",");
        }
  
        return text;
      },
      validateTicketCount() {
        let count = 0;
        this.DistributorCollection.map(x => {
          x.map(y => {
            y.Data.map(z => {
              count += parseFloat(z.Sold);
            });
          });
        });
        return count;
      }
    },
  
    methods: {
      moment,
      getCinemaList: function(cine_id) {
        this.Cinemas = [];
        MasterService.GetCinemasByRoles({ cine_id: cine_id })
          .then(response => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.Cinemas = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectHandler(event, type) {
        if (type == "cinema") {
          this.cinema_id = event.cine_id;
          this.selectedCinema = event;
        } else if (type == "distributor") {
            console.log("distributor=>",event)
          this.d_id = event.d_id;
          this.selectedMovie = [];
          this.MovieList = [];
          this.fetchDistributorMovies();
          // this.selectedDistributor = event;
        }
        else if (type == "movie") {
          this.movie_id = event.md_id;
          // this.selectedMovie = event;
        }
      },
      onRemoveHandler(event, type) {
        if (type == "cinema") {
          this.cinema_id = null;
          this.selectedCinema = "";
        } else if (type == "distributor") {
          this.d_id = null;
          // this.selectedDistributor = [];
        }
        else if (type == "movie") {
          this.movie_id = null;
          // this.selectedMovie = [];
        }
      },
      fetchDistributorMovies() {
        if (!this.cinema_id) {
          this.$toasted.show("Please Select Cinema");
          this.selectedDistributor = [];
          this.$forceUpdate();
        } else {
          this.MovieList = [];
          let payload = {
            fromDate: this.fromDate,
            toDate: this.toDate,
            cinema_id: this.cinema_id,
            cinema_name: this.selectedCinema.cine_name,
            d_id: this.selectedDistributor.d_id,
            movie_id: this.movieIds,
            // d_company_name: this.selectedDistributor
            //   .map(x => x.d_company_name)
            //   .join(","),
            d_company_name: this.selectedDistributor.d_company_name,
            country_id: authenticationService.get("BRGLOPCO"),
            filter_with_key: "ss_actual_start_date"
          };
          ReportsService.GetDistributorMovieFormat(payload)
            .then(response => {
              const { data } = response;
              if (data && data.status && data.Records) {
                this.MovieList = data.Records;
              } else
                this.$toasted.show(data.message || "Opps! Something went wrong");
            })
            .catch(error => {
              this.$toasted.show(
                "Catch Error on ReportStore fetchDistributorMovies",
                error
              );
            });
        }
      },
      getDistributorShareData: function(isPdf="N",isExcel="N") {
        this.distributorShareSummaryData = [];
        if (new Date(this.fromDate) > new Date(this.toDate)) {
          this.$toasted.show("From date should not be greater than To date.");
          return
        } else if (!this.cinema_id) {
          this.$toasted.show("Please Select any Cinema.");
          return
        }
        else if (!this.selectedDistributor || !this.selectedDistributor.d_id) {
          this.$toasted.show("Please Select any Distributor.");
          return
        }
          let loader = this.$loading.show();
  
        let payload = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          cinema_id: this.cinema_id,
          cinema_name: this.selectedCinema.cine_name,
          d_id: this.selectedDistributor.d_id,
          movie_id: this.movieIds,
          d_company_name: this.selectedDistributor.d_company_name,
        isPdf,
        isExcel
        };
        ReportsServiceV2.getDistributorShareSummaryWeekWiseData(payload)
          .then(async response => {
            const { data } = response;
            if (data && data.status && data.Records) {
              console.log("data.records=>", data.Records);
              this.distributorShareSummaryData = data.Records;
              this.grandTotal = data.grandTotal;
              if(isPdf=="Y" && data.pdfPath){
                window.open(data.pdfPath,"_blank")
            }
            if(isExcel=="Y" && data.excelPath){
                window.open(data.excelPath,"_blank")
            }
            } else {
              this.toasted.show(data.message);
            }
          })
          .catch(error => {
            console.log("ERROR:", error);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 500);
          });
      },
      ...mapActions([
        // FETCH FROM MASTER STORE
        "fetchCinemasList",
        // "fetchDistributorsList",
        // "fetchDistributorsActiveMasterMovie",
        // FETCH LIST ONLY
        "fetchReportDistributorsList",
        "fetchDistributorReportList",
        "onDistributorReportDateHandler",
        "onDistributorReportDropdownHandler",
        "onDistributorReportFlagHandler",
        "onResetDistributorStoreState"
      ])
    }
  };
  </script>
  <style scoped>
  .color-blue {
    background-color: #cccccc;
  }
  .text-bold {
    font-weight: bold;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/distributorShareSummaryWeekWiseReport.vue